import type { Action, SubjectRoles } from "@/api-schema-enums";
import type { FeatureFlag } from "@/config/feature-flags";
import type { TFunction } from "i18next";
import type { ComponentType } from "react";
import type { RouteComponentProps } from "wouter";

export type PermissionRequirement = {
  action: Action;
  subject: string;
};

export type AppRoleRequirement = {
  appRole: SubjectRoles;
};

export enum PermissionOperator {
  AND = "AND",
  OR = "OR",
}

export type PermissionGroup = {
  operator: PermissionOperator;
  permissions: NavigationPermission[];
};

export type NavigationPermission = PermissionRequirement | PermissionGroup | AppRoleRequirement;

export type RouteAudienceRole = SubjectRoles.Int | SubjectRoles.Ext;
export type RouteAudience = RouteAudienceRole | RouteAudienceRole[];

export type NavigationCommand = {
  id: string;
  title: () => string;
  to: string;
  icon?: React.ElementType;
  permission?: NavigationPermission;
};

export type NavigationItem = {
  id: string;
  title: () => string;
  routePath?: string;
  component?: ComponentType<RouteComponentProps>;
  audience?: RouteAudience;
  nest?: boolean;
  icon?: React.ElementType;
  permission?: NavigationPermission;
  featureFlag?: FeatureFlag;
  featureFlagFallbackPermission?: NavigationPermission;
  children?: NavigationItem[];
  videoTutorialUrl?: string;
  hideFromSidebar?: boolean;
  navigable?: boolean;
  breadcrumbLabel?: (t: TFunction) => string;
  breadcrumbDisableUuidDetails?: boolean;
  breadcrumbSegment?: string;
  hiddenFromBreadcrumb?: boolean;
  commands?: NavigationCommand[];
};
